import { withStyles } from '@material-ui/core';
import List from './List';
import styles from './List.styles';

export default withStyles(styles)(List);
